import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import AppModule from '@returns-centre/store/modules/AppModule';
import ShopModule from '@returns-centre/store/modules/ShopModule';
import TradeInModule from '@returns-centre/store/modules/TradeInModule';
import CustomerModule from '@returns-centre/store/modules/CustomerModule';
import ReturnCarrierServiceModule from '@returns-centre/store/modules/ReturnCarrierServiceModule';


Vue.use(Vuex);


export const store = new Vuex.Store({
    modules: {
        appModule: AppModule,
    	shopModule: ShopModule,
    	customerModule: CustomerModule,
    	tradeInModule: TradeInModule,
    	returnCarrierServiceModule: ReturnCarrierServiceModule
    }
});


export { default as AppModule } from './modules/AppModule';
export { default as CustomerModule } from './modules/CustomerModule';
export { default as ReturnCarrierServiceModule } from './modules/ReturnCarrierServiceModule';
export { default as ShopModule } from './modules/ShopModule';
export { default as TradeInModule } from './modules/TradeInModule';

